import { SelectedFacet } from '@lessonup/typescript-core/domain';
import { Notification } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './CountryNotification.less';

interface Props {
  country: string | undefined;
  selectedFacets: SelectedFacet[];
  onClick: () => void;
}

export const CountryNotification: React.FunctionComponent<Props> = ({ country, selectedFacets, onClick }) => {
  const { t } = useTranslation('searchResultsCountryNotification');

  const button = {
    text: t('button'),
    onClick,
  };

  return (
    <>
      {country && !userIsFromSelectedCountry(selectedFacets, country) && (
        <Notification button={button} className="country-notification" image="globe">
          {t('message')}
        </Notification>
      )}
    </>
  );
};

function userIsFromSelectedCountry(selectedFacets: SelectedFacet[], country?: string) {
  return country && selectedFacets.find(({ key, value }) => key === 'country' && value.includes(country));
}
